// consumo.tsx
import React, { useEffect, useMemo, useState } from "react";
import TextFieldRow from "../../../../components/TextFieldRow";

type Props = {
  responsavelColeta: string;
  setResponsavelColeta: (v: string) => void;
  motivoConsumo: string;
  setMotivoConsumo: (v: string) => void;
};

const COLABS_URL =
  "https://api.eva-googlemarine.com/departamentos/recursos-humanos/colaboradores-nome";

const ConsumoMovement: React.FC<Props> = ({
  responsavelColeta,
  setResponsavelColeta,
  motivoConsumo,
  setMotivoConsumo,
}) => {
  // Estado das opções de colaboradores
  const [colabOptions, setColabOptions] = useState<string[]>([]);
  const [loadingColabs, setLoadingColabs] = useState(false);
  const [erroColabs, setErroColabs] = useState<string | null>(null);

  // Normaliza para MAIÚSCULO enquanto digita/seleciona
  const toUpper = (fn: (v: string) => void) => (v: string) =>
    fn((v || "").toUpperCase());

  // Busca colaboradores
  useEffect(() => {
    let alive = true;
    const ctrl = new AbortController();

    (async () => {
      setLoadingColabs(true);
      setErroColabs(null);
      try {
        const res = await fetch(COLABS_URL, {
          method: "GET",
          headers: { Accept: "application/json" },
          signal: ctrl.signal,
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);

        const json = await res.json();
        // Esperado: { data: [{ nome_completo: "Fulano" }, ...] }
        const list: string[] = Array.isArray(json?.data)
          ? (json.data as Array<{ nome_completo?: string }>).map((x) =>
              (x?.nome_completo ?? "").trim()
            )
          : [];

        const unique = Array.from(
          new Set(
            list
              .map((s) => (typeof s === "string" ? s.toUpperCase() : ""))
              .filter(Boolean)
          )
        );

        if (alive) setColabOptions(unique);
      } catch (e: any) {
        if (alive) setErroColabs(String(e?.message || e));
      } finally {
        if (alive) setLoadingColabs(false);
      }
    })();

    return () => {
      alive = false;
      ctrl.abort();
    };
  }, []);

  // Opções do dropdown (undefined quando vazio para manter comportamento do seu TextFieldRow)
  const colabDropdown = useMemo(
    () => (colabOptions.length ? colabOptions : undefined),
    [colabOptions]
  );

  return (
    <div>
      <TextFieldRow
        center={{
          label: "Destinatário da Coleta",
          value: responsavelColeta,
          onChange: toUpper(setResponsavelColeta),
          placeholder: loadingColabs
            ? "CARREGANDO COLABORADORES..."
            : erroColabs
            ? "FALHA AO CARREGAR. DIGITE MANUALMENTE."
            : "SELECIONE O DESTINATÁRIO DA COLETA",
          options: colabDropdown, // dropdown com colaboradores
        }}
      />

      <TextFieldRow
        center={{
          label: "Para que será utilizado?",
          value: motivoConsumo,
          onChange: setMotivoConsumo,
          placeholder: "Digite aqui o motivo da coleta",
        }}
      />
    </div>
  );
};

export default ConsumoMovement;
